/**
 * OVERRIDE ImageView.jsx
 * REASON: Using custom component to render Image and Caption.
 * DATE: 2023-07-19
 * DEVELOPER: @IFlameing
 */

import ImageView from '../../../../../components/Theme/ImageView';

export default ImageView;
